module.exports = __webpack_public_path__ + "static/media/canada.a4122561.png";